const { cloneDeep } = require('lodash')

const dayjs = require('dayjs')
const isBetween = require('dayjs/plugin/isBetween')

dayjs.extend(isBetween)

const { collectDay, monthAndRemainDays } = require('./utils')

const btp = {
  threeMonth: 3,
  halfYear: 6,
  year: 12,
  month: false,
  monthN: false,
  thirty: false,
  week: false,
  day: false,
  once: false,
}

/**
 * @desc 计算阶梯对应日期
 * @param {Date} st - 开始时间
 * @param {Array} configList - 阶梯配置
 * @returns {Array} configList
 */
export function dateConversion(st, configList) {
  const newArray = cloneDeep(configList)
  newArray.forEach((item, index) => {
    if (index > 0) {
      const startDate = dayjs(st).add(item.startMonth - 1, 'months').format('YYYY-MM-DD')
      const endDate = dayjs(st).add(item.endMonth, 'months').subtract(1, 'days').format('YYYY-MM-DD')
      item.startDate = startDate
      item.endDate = endDate
    } else {
      const endDate = dayjs(st).add(item.endMonth, 'months').subtract(1, 'days').format('YYYY-MM-DD')
      item.startDate = dayjs(st).format('YYYY-MM-DD')
      item.endDate = endDate
    }
    item.idx = index
  })
  return newArray
}

/**
 * @desc 判断是否在时间段内，并返回时间段对应的租金
 * @param {Date} st - 开始时间
 * @param {Date} ent - 结束时间
 * @param {Array} stairDateList - 阶梯集合
 * @return {isSameStair, timeStair} boolean-是否在一个阶梯，timeStair-阶梯集合
 */
export function isBetweenRange(st, ent, stairDateList) {
  const stairList = stairDateList.map((item) => {
    return {
      amount: item.amount,
      startDate: item.startDate,
      endDate: item.endDate,
      idx: item.idx,
    }
  })
  // 开始时间和结束时间都在某一个阶梯内，返回一个租金
  // 开始时间在一个阶梯，结束时间在另一个阶梯，返回两个租金，并且需要开始时间到本阶梯结束的天数，结束时间到本阶梯开始时间的天数

  // 开始时间所在的阶梯下标
  const stIdx = stairList.findIndex((item) => {
    const fst = dayjs(st).format('YYYY-MM-DD')
    if (fst === item.startDate || fst === item.endDate) {
      return item
    } else {
      return dayjs(st).isBetween(item.startDate, item.endDate)
    }
  })
  // 结束时间所在的阶梯下标
  const entIdx = stairList.findIndex((item) => {
    const fent = dayjs(ent).format('YYYY-MM-DD')
    if (fent === item.startDate || fent === item.endDate) {
      return item
    } else {
      return dayjs(ent).isBetween(item.startDate, item.endDate)
    }
  })

  // 开始时间和结束时间在同一个阶梯内
  if (stIdx === entIdx) {
    return {
      isSameStair: true,
      timeStair: JSON.stringify([stairList[stIdx]]),
    }
  // 开始时间和结束时间在两个阶梯内
  } else if (entIdx - stIdx === 1) {
    return {
      isSameStair: false,
      timeStair: JSON.stringify([stairList[stIdx], stairList[entIdx]]),
    }
  // 开始时间和结束时间跨度大于两个阶梯
  } else if (entIdx - stIdx > 1) {
    return {
      isSameStair: false,
      // eslint-disable-next-line array-callback-return
      timeStair: JSON.stringify(stairList.filter((i, index) => {
        if (index >= stIdx && index <= entIdx) {
          return i
        }
      })),
    }
  } else {
    console.error('阶梯日期配置有误，阶梯时间范围小于合同周期')
  }
}


/**
 * @desc 给每个周期加上匹配的阶梯对象
 * @param {Boolean} isOpen - 是否开启阶梯配置
 * @param {Date} ladderDate - 阶梯集合
 * @param {Array} cycleArr - 周期详情
 * @return {Array} 周期详情集合
 */
export function addStairAmount(isOpen, ladderDate, cycleArr) {
  const newArray = cloneDeep(cycleArr)
  const newCycleArr = newArray.map((item) => {
    const stairAmount = isOpen && isBetweenRange(item.startCycleDate, item.endCycleDate, ladderDate) // 阶梯金额
    return {
      ...item,
      stairAmount,
    }
  })
  return newCycleArr
}

/**
 * @desc 重新计算每个周期的金额
 * @param {String} paymentType - 支付方式
 * @param {Array} ar - 周期集合
 */
export function reCalculatePlanAmount(paymentType, ar, dailyRule) {
  ar.forEach((item, index) => {
    const isSame = item.stairAmount.isSameStair
    const timeStairArr = JSON.parse(item.stairAmount.timeStair)
    if (isSame) { // 本账期都在同一个阶梯
      // 因为自然月的第一个账期永远不会跨阶梯且在周期详情方法里边已经计算过了，所以无需重新计算
      if (!(paymentType === 'monthN' && index === 0)) {
        item.planAmount = timeStairArr[0].amount
      }
    } else { // 计算跨账期的金额
      // 计算本账期天数和
      let tds
      // 如果 收/付款方式 为 [满月]或者是 [自然月]，且日租金规则为0或者1(0：按照开始月自然天数 1：按照30天)，其他付款方式按照 开始时间和结束时间的差计算
      if (paymentType === 'month' || paymentType === 'monthN') {
        tds = dailyRule ? 30 : dayjs(item.startCycleDate).daysInMonth()
      } else {
        tds = dayjs(item.endCycleDate).diff(item.startCycleDate, 'day') + 1
      }
      // 计算跨账期金额
      calculateAcrossAmount(item, tds, timeStairArr, paymentType)
    }
  })

  // 重新计算最后一个账期的金额

  const lastCycle = ar[ar.length - 1]
  // 计算对应付款方式的固定周期的实际总天数
  const laMonAlDa = collectDay(lastCycle.startCycleDate, paymentType, dailyRule)
  const timeStairArr2 = JSON.parse(lastCycle.stairAmount.timeStair)


  // 没有跨账期
  if (lastCycle.stairAmount.isSameStair) {
    // 年付、半年付、三个月付 的计算方式需要先算满月，再算剩余天
    if (btp[paymentType]) {
      const mountObj_last = monthAndRemainDays(lastCycle.startCycleDate, lastCycle.endCycleDate)
      const lastMount_months = timeStairArr2[0].amount / btp[paymentType] * mountObj_last.totalMonth
      const lastMount_days = timeStairArr2[0].amount / btp[paymentType] / mountObj_last.lastPeriodTotalDays * mountObj_last.remainDays
      lastCycle.planAmount = Math.ceil((lastMount_months + lastMount_days).toFixed(2))
    } else {
      // 计算本账期天数和
      const tds = dayjs(lastCycle.endCycleDate).diff(lastCycle.startCycleDate, 'day') + 1
      const mount = (timeStairArr2[0].amount) / laMonAlDa * tds
      const planAmount = (Number(mount) > Number(timeStairArr2[0].amount) || Number(mount) === Number(timeStairArr2[0].amount)) ? Number(timeStairArr2[0].amount) : Number(mount)
      lastCycle.planAmount = Math.ceil(planAmount.toFixed(2))
    }
  // 有跨账期
  } else {
    calculateAcrossAmount(lastCycle, laMonAlDa, timeStairArr2, paymentType)
  }
}

/**
 * @desc 计算跨账期的金额
 * @param {Object} item 当前账期对象
 * @param {Number} tds 对应付款方式的账期固定总天数
 * @param {Array} timeStairArr 当前账期对象中对应的阶梯数据
 * @param {String} paymentType 收/付款方式（年付/周付/半年付/三个月付/满月/自然月付等）
 */
export function calculateAcrossAmount(item, tds, timeStairArr, paymentType) {
  if (timeStairArr.length === 2) { // 跨两个账期，单独计算
    // 年付、半年付、三个月付 的计算方式需要先算满月，再算剩余天
    if (btp[paymentType]) {
      // 跨左边阶梯的时间段共有几个月和几天
      const mountObj_left = monthAndRemainDays(item.startCycleDate, timeStairArr[0].endDate)
      // 跨右边阶梯的时间段共有几个月和几天
      const mountObj_right = monthAndRemainDays(timeStairArr[1].startDate, item.endCycleDate)

      // 跨左边阶梯所占月份数量的金额（公式 = 阶梯金额 / 付款方式对应的月份数 * 跨左边阶梯所占满月的月份数量）
      const leftMount_months = timeStairArr[0].amount / btp[paymentType] * mountObj_left.totalMonth
      // 跨左边阶梯所占天数量的金额（公式 = 阶梯金额 / 付款方式对应的月份数 / 不满月的最后一个(周期)开始时间的月份总天数 * 跨左边阶梯所占月份数量）
      const leftMount_days = timeStairArr[0].amount / btp[paymentType] / mountObj_left.lastPeriodTotalDays * mountObj_left.remainDays

      // 跨右边阶梯所占月份数量的金额（公式 = 阶梯金额 / 付款方式对应的月份数 * 跨右边阶梯所占满月的月份数量）
      const rightMount_months = timeStairArr[1].amount / btp[paymentType] * mountObj_right.totalMonth
      // 跨右边阶梯所占天数量的金额（公式 = 阶梯金额 / 付款方式对应的月份数 / 不满月的最后一个(周期)开始时间的月份总天数 * 跨右边阶梯所占天的数量）
      const rightMount_days = timeStairArr[1].amount / btp[paymentType] / mountObj_right.lastPeriodTotalDays * mountObj_right.remainDays

      item.planAmount = Math.ceil((leftMount_months + leftMount_days + rightMount_months + rightMount_days).toFixed(2))
    } else {
      // 计算账期开始时间到第一个阶梯结束时间的天数差
      const a = dayjs(timeStairArr[0].endDate).diff(item.startCycleDate, 'day') + 1
      // 计算第二个阶梯开始时间到账期结束时间的天数差
      const b = dayjs(item.endCycleDate).diff(timeStairArr[1].startDate, 'day') + 1

      const pA = timeStairArr[0].amount / tds * a
      const pB = timeStairArr[1].amount / tds * b

      item.planAmount = Math.ceil((pA + pB).toFixed(2))
    }
  } else { // 跨两个以上账期
    // 年付、半年付、三个月付 的计算方式需要先算满月，再算剩余天
    // eslint-disable-next-line no-lonely-if
    if (btp[paymentType]) {
      // 跨第一个阶梯的时间段共有几个月和几天
      const mountObj_fist = monthAndRemainDays(item.startCycleDate, timeStairArr[0].endDate)
      // 跨最后一个阶梯的时间段共有几个月和几天
      const mountObj_last = monthAndRemainDays(timeStairArr[timeStairArr.length - 1].startDate, item.endCycleDate)

      // 跨第一个阶梯所占月份数量的金额（公式 = 阶梯金额 / 付款方式对应的月份数 * 跨第一个阶梯所占满月的月份数量）
      const firstMount_months = timeStairArr[0].amount / btp[paymentType] * mountObj_fist.totalMonth
      // 跨第一个阶梯所占天数量的金额（公式 = 阶梯金额 / 付款方式对应的月份数 / 不满月的最后一个(周期)开始时间的月份总天数 * 跨第一个阶梯所占天的数量）
      const firstMount_days = timeStairArr[0].amount / btp[paymentType] / mountObj_fist.lastPeriodTotalDays * mountObj_fist.remainDays

      // 跨最后一个阶梯所占月份数量的金额（公式 = 阶梯金额 / 付款方式对应的月份数 * 跨第一个阶梯所占满月的月份数量）
      const lastMount_months = timeStairArr[timeStairArr.length - 1].amount / btp[paymentType] * mountObj_last.totalMonth
      // 跨最后一个阶梯所占天数量的金额（公式 = 阶梯金额 / 付款方式对应的月份数 / 不满月的最后一个(周期)开始时间的月份总天数 * 跨最后一个阶梯所占天的数量）
      const lastMount_days = timeStairArr[timeStairArr.length - 1].amount / btp[paymentType] / mountObj_last.lastPeriodTotalDays * mountObj_last.remainDays

      // 计算除了头和尾的 amount 之和
      const middleTotal = timeStairArr.reduce((total, per, index) => {
        if (index > 0 && index < timeStairArr.length - 1) {
          // 计算中间的每个阶梯所占月份数量
          const mountObj_middle = monthAndRemainDays(per.startDate, per.endDate)
          // 再计算每个阶梯的金额，因为中间的每个阶梯最少都是满月的，所以不需要计算剩余天数的金额
          // （公式 = 阶梯金额 / 付款方式对应的月份数 * 中间每个阶梯所占满月的月份数量）
          const mounts = per.amount / btp[paymentType] * mountObj_middle.totalMonth
          total += mounts
        }
        return total
      }, 0)

      item.planAmount = Math.ceil((firstMount_months + firstMount_days + middleTotal + lastMount_months + lastMount_days).toFixed(2))
    } else {
      // 计算账期开始时间到第一个阶梯结束时间的天数差
      const a = dayjs(timeStairArr[0].endDate).diff(item.startCycleDate, 'day') + 1
      // 计算最后一个阶梯开始时间到账期结束时间的天数差
      const b = dayjs(item.endCycleDate).diff(timeStairArr[timeStairArr.length - 1].startDate, 'day') + 1

      const pA = timeStairArr[0].amount / tds * a
      const pB = timeStairArr[1].amount / tds * b

      // 计算除了头和尾的 amount 之和

      const middleTotal = timeStairArr.reduce((total, per, index) => {
        if (index > 0 && index < timeStairArr.length - 1) {
          // 计算前后日期差
          const differDays = dayjs(per.endDate).diff(per.startDate, 'day') + 1
          // 再计算各个阶梯的金额
          const mounts = per.amount / tds * differDays
          total += mounts
        }
        return total
      }, 0)

      item.planAmount = Math.ceil((pA + pB + middleTotal).toFixed(2))
    }
  }
}

// module.exports = {
//   dateConversion,
//   isBetweenRange,
//   addStairAmount,
//   reCalculatePlanAmount
// }
